export default {
  // 自定义后台数据
  custom_backstage: {
    customApp: 'Custom application',
    expertsService: 'Expert customization service',
    selectAppTemplate: 'Application template selection',
    creatNewApp: 'Create a new app',
    juhe: 'Aggregate table',
    app: 'application',
    module: 'module',
    myApp: 'my app',
    uploadApp: 'Upload application',
    noNameApp: 'Unnamed app',
    editIcon: 'Edit Icon',
    appName: 'apply name',
    moduleName: 'Module name',
    moduleType: 'Module type',
    creatModule: 'Create module',
    newBuildModule: 'New module',
    editModule: 'Edit module',
    creatApp: 'Create application',
    editApp: 'Editing applications',
    name: 'name',
    moduleIcon: 'Module Icon',
    creater: 'Founder',
    createTime: 'Creation time',
    nameMustfill: 'Name is required',
    modifyPer: 'Modified by',
    modifyTime: 'Modification time',
    transfer: 'transfer',
    transferTo: 'Transfer to',
    transferToShare: 'Share with current data analysis leader after transfer',
    transferAfter:
      'Transfer the person in charge of the current data to another person in charge? After the transfer is successful, the operation cannot be restored',
    selectTransferPer: 'Please select transfer personnel',
    transferComplete: 'Transfer successful',
    rongjiuDelDataIsGoon:
      'This operation will permanently delete the data. Do you want to continue?',
    juheName: 'Aggregate table name',
    dataSource: 'data source',
    nodataRightadd: 'No data, please add from the right side',
    theDataSource: 'data sources',
    rowTable: 'Row header',
    add: 'add to',
    guanlianField: 'Associated fields',
    columnTable: 'List header',
    tongjizhibiao: 'statistical indicators',
    screenContion: 'Screening criteria',
    visibility: 'visibility',
    kexuanbumen: 'Department, member and role can be selected, and multiple selection is supported',
    run: 'function',
    oneTabledata: 'Single table data',
    moreTableGuanlian: 'Multi table Association',
    dataTable: 'data sheet',
    selectGuanlianData: 'Please select associated data',
    jianyanInfo_1: 'Data source cannot be empty',
    jianyanInfo_2:
      'There is at least one main table field in row header, list header and statistical indicator',
    jianyanInfo_3: 'Row header cannot be empty',
    jianyanInfo_4: 'Statistical index cannot be empty',
    jianyanInfo_5: 'Aggregate table name cannot be empty',
    jianyanInfo_6: 'Statistical indicator name cannot be empty',
    jianyanInfo_7: 'Statistical index formula cannot be empty',
    jianyanInfo_8: 'The name of statistical indicator cannot be duplicate',
    jianyanInfo_9: 'Data has not been saved, exit?',
    jianyanInfo_10: 'Select 5 data tables at most',
    jianyanInfo_11: 'The data already exists',
    jianyanInfo_12: 'Data table cannot be empty',
    jianyanInfo_13: 'Field association cannot be empty',
    jianyanInfo_14:
      'This operation will reset the previously set parameters. Do you want to continue?',
    appNameNotEmpty: 'Application name cannot be empty',
    uploaderNotEmpty: 'Uploader cannot be empty',
    onePicUpload: 'Please upload at least one app image',
    descNotEmpty: 'Description cannot be empty',
    priceNotEmpty: 'Price cannot be empty',
    formatError: 'Format error',
    accountNotEmpty: 'Account number cannot be empty',
    appDetail: 'Application details',
    baseInfo: 'essential information',
    Industry: 'Industry',
    appType: 'Application classification',
    uploader: 'Uploaded by',
    appScreenshot: 'Application screenshot',
    uploadPic8:
      "Please upload the screenshots of the app's web side and app side, no more than 8 in total",
    functionInfo: 'Function introduction',
    appDesc: 'Application description',
    payInfo: 'Charge information',
    ifPay: 'Whether the charge',
    Price: 'Price',
    receivingAccount: 'Payment account',
    payInfoToTeamface:
      'Every payment needs to go through a 7-day fund review period, and the payment will be automatically transferred to the account after the end;Account number is very important, please fill in carefully;If there is any mistake, please contact certificate platform customer service in time',
    penddingShenhe: 'Submitted successfully, please wait for system review!',
    seeeProgress: 'Check out the progress in app Center - My Upload',
    free: 'free',
    pay: 'pay',
    alipay: 'alipay',
    wechat: 'wechat',
    oneInputOneOption: 'One option can be entered per line',
    moveModule: 'Mobile module',
    suoshuApp: 'Application',
    pleaseInputDelModuleName: 'Please enter the module name to be deleted',
    appHaveModule: 'There are modules under the application, please delete the module first',
    sureDelApp:
      'It will not be recovered after deletion. Are you sure you want to delete this app?',
    moduleNameInputError: 'Wrong module name',
    pageLayout: 'Page layout',
    approvalProcess: 'Approval process',
    globalSettings: 'Global settings',
    moduleRelease: 'Module release',
    noAuthOperateApprovalProcess: 'No permission to operate the approval process',
    pleaseSaveCustomLayout: 'Please save the custom layout first',
    highContionSet: 'Advanced condition setting',
    before: 'before',
    after: 'after',
    highContion: 'Advanced conditions',
    addFilterContion: 'Add filter condition',
    illegalFormula: 'The formula is illegal',
    pleaseInputFormula: 'Please fill in the formula correctly',
    contionSetWarning: 'Condition setting error',
    contionFormula: 'Conditional formula',
    contionMax2:
      'Advanced conditions can only be used if the condition is greater than or equal to 2',
    highContionInfo1: 'Note: 1. No nonexistent serial number is allowed',
    highContionInfo2: 'E.g. 1 and 2 and 3 and 4...',
    highContionInfo3: '2. With and and or, you must have parentheses',
    highContionInfo4: 'E.g.1 and 2 or 3 、(1 and 2) and 3 or 4',
    highContionInfo5: '(1 and 2) or (3 or 4) and (5 or 6);',
    highContionInfo6: '(1 and 2 or 3) and 4',
    highContionInfo7: '3. A parenthesis cannot be used with AND and OR',
    highContionInfo8: '1 and 2 or 3 and 4;The parentheses come in pairs',
    highContionInfo9:
      'You can use OR,AND,NOT AND English parentheses to form a logical relationship to the above conditions',
    highContionInfo10:
      'For example, (1 AND 2) OR 3 means that the first AND second conditions AND relations are followed by the third condition OR operation',
    selectInsetField: 'Select insert field',
    selectSubformName: 'Select sub table name',
    selectFieldName: 'Select field name',
    selectSubModule: 'Select sub module',
    fun: 'function',
    AllFunType: 'All function categories',
    insertFun: 'Insert selected function',
    insertYunsuanfu: 'insertion operator',
    operator: 'operator',
    manzuContionShowThisMsg: 'This message is displayed under the conditional formula',
    gongshiErrorOnlyone: 'Error in formula, please select at least one function to insert',
    formulaDontUseTihua:
      'The formula content cannot contain the sign of ["], please replace it with [\\ \']',
    fieldNothereFormulaSetting:
      'The field does not exist, please adjust the formula settings again',
    CdtFormulaRequired: 'Conditional formula is required',
    tipsTextRequired: 'Prompt text is required',
    ordinalParameter: 'Ordinal parameter',
    submitCheck: 'Submit verification',
    formula: 'Simple formula',
    functionformula: 'Function formula',
    citeformula: 'Quoting formula',
    seniorformula: 'Advanced formula',
    fixedValue: 'Fixed value',
    sequenceNumber: 'Sequence number',
    sequenceNumberRequired: 'Sequence number is required',
    identiferInfo1: '1. Fixed value: input text or letter',
    identiferInfo2: '2. Date: {yyyy} = year; {mm} = month; {DD} = day',
    identiferInfo3:
      '3. Sequence number: {0001} = sequence number. The number of digits and the starting number can be defined',
    identiferInfo4:
      'For example, {00002} means that the sequence number is 5 digits, and the next number is automatically calculated from 2',
    chanceStyle: 'Change style',
    systemInfo: 'system information',
    mobilePhone: 'mobile phone',
    wenben: 'text',
    personnel: 'personnel',
    currentPersonnel: 'Current members',
    text: 'Single line text',
    textarea: 'Multiline text',
    multitext: 'Rich text',
    picklist: 'Drop down options',
    phone: 'phone',
    email: 'email',
    number: 'number',
    datetime: 'Date / time',
    attachment: 'enclosure',
    url: 'Hyperlinks',
    location: 'location',
    picture: 'picture',
    multi: 'check box',
    mutlipicklist: 'Multi level pull down',
    department: 'department',
    onlyDepartmentVisible: 'Visible only to the owning department',
    area: 'Province and city',
    identifier: 'auto number',
    serialnum: 'Serial number',
    reference: 'Association',
    subform: 'Subform',
    barcode: 'bar code',
    resumeanalysis: 'Resume analysis',
    signature: 'Handwritten signature',
    changyongField: 'Common fields',
    fieldComponent: 'Field component',
    baseField: 'Basic field',
    seniorComponent: 'Advanced class components',
    highVersionComponent: 'Later components',
    thisOperateDelSetIsgoon:
      'This action will permanently delete the component and its property settings',
    thisOperateIsGoon: 'Do you want to continue?',
    warning: 'warning',
    moduleChangeIsSave: 'Module content has been changed, do you want to save it?',
    fieldNameNotEmpty: 'Field name cannot be empty',
    moduleNameNotEmpty: 'Module name cannot be empty',
    moduleTypeNotEmpty: 'Module type cannot be empty',
    templateModule: 'Template module',
    pleaseInputTemplateName: 'Please enter the name of the template to be deleted',
    customTemplate: 'Custom template',
    projectTemplate: 'Collaboration template',
    taskTemplate: 'Task template',
    platformTemplate: 'Platform template',
    moduleSet: 'Module settings',
    detailsControl: 'Detail control',
    terminal: 'terminal',
    setAppearance: 'Set appearance',
    themeStyle: 'Theme style',
    attributeStyle: 'Attribute style',
    holisticStyle: 'Overall style',
    pageBackground: 'Page background',
    tableHeadStyle: 'Header style',
    headBackground: 'Head background',
    mainTitle: 'Main title',
    moduleDesc: 'Module description',
    descText: 'Description text',
    contentStyle: 'Content style',
    contentBackground: 'Content background color',
    submitStyle: 'Submission area style',
    submitBackground: 'Submission background',
    submitStyleNew: 'Submission style',
    submitFeedback: 'Submit feedback',
    buttonColor: 'Button color',
    selectColor: 'Choose a color',
    buttonShow: 'Button display',
    singleButton: 'Single button',
    dobuleButton: 'Double button',
    buttonText: 'Button text',
    buttonWidth: 'Button width',
    buttonPosition: 'Button position',
    moduleAppearance: 'Module appearance',
    columnsSet: 'Column setting',
    columnsName: 'Column name',
    showHidden: 'Show / hide',
    defaultHiddenColumn: 'Collapse columns by default',
    addEditHiddenCloumnName: 'Hide column name on new / edit page',
    addEditHiddenCloumn: 'Hide in add / edit page',
    detailsHiddenCloumn: 'Hide in details page',
    fieldSet: 'Field settings',
    fieldName: 'Field name',
    tipsText: 'Prompt text',
    default: 'Default value',
    mappingField: 'Mapping fields',
    set: 'set',
    type: 'type',
    optionContent: 'Option content',
    batchAdd: 'Batch add',
    digit: 'digit',
    decimalDigit: 'Decimal places',
    fengefu: 'Separator',
    inputRange: 'Input range',
    dontInputUnlimited: 'If not, there is no limit',
    numberControl: 'Quantity control',
    noLimit: 'Unlimited',
    limit: 'limit',
    sizeRequire: 'Dimensional requirements',
    yiji: 'one-level',
    erji: 'second level',
    sanji: 'Three levels',
    twoPulldown: 'Secondary pull down',
    threePulldown: 'Three level pull down',
    oneOption: 'First level options',
    twoOption: 'Secondary options',
    threeOption: 'Three level options',
    addOption: 'Add options',
    oneDefault: 'Primary default value',
    twoDefault: 'Secondary default',
    threeDefault: 'Three level default value',
    chooseRange: 'Optional range',
    setFormula: 'Set formula',
    dataType: 'data type',
    returnType: 'Return type',
    jingquedu: 'accuracy',
    bianhaoResult: 'Numbering results',
    setBianhaoRule: 'Set numbering scheme',
    referenceModule: 'Association module',
    referenceField: 'Associated fields',
    buttonConfig: 'Button configuration',
    listSearchField: 'List search fields',
    scan: 'Scan code',
    barcordComponent:
      'This function is only valid for mobile app, and the associated module must store barcode components',
    scanInput: 'Scan code input',
    onlyOneSetScan: 'Only one scan function is allowed',
    setScreenContion: 'Set association filter criteria',
    addScreenContion: 'Add filter criteria',
    subformStyle: 'Subform style',
    table: 'table',
    card: 'card',
    subformField: 'Subform field',
    selectFIeldAddToTable: 'Select the fields to add to the subform',
    subfromDefalut: 'Subform default values',
    ifEditShowDefaultSet: 'Whether the edit page has no value displays the default Settings',
    addressLocation: 'Address location',
    defaultLocation: 'Default current position',
    serialnumFule: 'Rule of serial number',
    field: 'field',
    date: 'date',
    addFule: 'Add rule',
    fieldWidth: 'Field width',
    singleColumn: 'Single column',
    doubleColumn: 'double column',
    threeCloumn: 'Three columns',
    fourCloumn: 'Four columns',
    fieldStructure: 'Field structure',
    leftRightLayout: 'Left and right layout',
    topBottomLayout: 'Top down layout',
    fieldControl: 'Field control',
    redayOnly: 'read-only',
    noControl: 'Out of control',
    fieldAuth: 'Field permissions',
    addShow: 'Display when adding',
    editShow: 'Show when editing',
    detailShow: 'When the details are displayed',
    radio: 'Single choice',
    multiple: 'Multiple choice',
    phoneNumber: 'phone number',
    domestic11: 'Domestic 11',
    unlimited: 'unlimited',
    ProjectMembers: 'Project members',
    currentDepartment: 'Current department',
    provinceCity: 'Provinces and cities',
    province: 'province',
    city: 'city',
    area1: 'area',
    currentTime: 'current time',
    zhidingTime: 'Specified time',
    checkedRepeat: 'Duplicate check',
    donotEnablecheckdRepeat: 'Do not enable duplicate checking',
    enablecheckdRepeat1: 'Enable duplicate checking and allow data to be saved',
    enablecheckdRepeat2: 'Enable duplicate check, not allowed to save data',
    noOpacity: 'Opaque',
    auto: 'self-adaption',
    forTableWidth: 'Same width as form',
    internationalCode: 'International Code',
    customCode: 'Custom coding',
    option: 'option',
    newOption: 'New options',
    oneNewOption: 'First level new options',
    twoNewOption: 'Second level new options',
    threeNewOption: 'Third level new options',
    sureDelCutomField: 'Are you sure you want to delete the custom field (not recoverable)?',
    listLayout: 'List layout',
    max3RowData: 'You can only add 3 rows of data at most',
    max3ColumnData: 'You can only add up to 3 columns of data',
    biaochunPageNotSave: 'Standard page layout not saved',
    saveListLayoutSuccess: 'List layout saved successfully',
    saveFail: 'Save failed',
    outLinkExtendlist: 'External chain extension list',
    extendNameRequire: 'Extension (required)',
    extendValueRequire: 'Extended value (required)',
    extendNameRequire1: 'Extension name must be filled in',
    extendValueRequire1: 'Extended value must be filled in',
    jiexiAfterAutoInput:
      'After parsing, the extracted fields are automatically filled into the user-defined fields',
    customField: 'Custom fields',
    jiexiField: 'Parse field',
    valueDuiyingTo: 'The value of corresponds to',
    cutomJiexieFieldNotEmpty: 'Custom field and resolution field cannot be empty',
    formulaNew: 'formula',
    addPage: 'New page',
    AppListLayout: 'Mobile terminal layout',
    webform: 'Web forms',
    biaozhunPage: 'Standard page',
    subPage: 'Subpage',
    liushuiRuleNotEmpty: 'Serial number rule cannot be empty',
    oneOtionValue: 'At least one option value is required',
    bianhaoRuleNotEmpty: 'Number sequence cannot be empty',
    computeNotEmpty: 'Calculation formula cannot be empty',
    thisOprateDelPageIsGoon:
      'This operation will permanently delete the page. Do you want to continue?',
    saevFailNetworkClickSyn:
      'There is a network connection failure message when saving the page layout. To ensure the normal use of the page layout, please click the "synchronization" button to continue',
    synSuccess: 'Synchronization succeeded',
    syn: 'synchronization',
    modulePushSuccess: 'Module published successfully, you can continue to create modules~',
    goonCreate: 'Continue creating',
    firstWebform: 'First web form',
    webformNameNotEmpty: 'The name cannot be empty',
    webformPwdNotEmpty: 'Password cannot be empty',
    webformPwd6: 'The password length of the form is 6 digits',
    validationFieldNotEmpty: 'Validation field cannot be empty',
    fieldNotEmpty: 'Field cannot be empty',
    sameWebformName: 'The same form name exists. Is it the same activity?',
    approvalSaveUse: 'Save and use',
    approvalReset: 'Reset',
    approvalRevoke: 'revoke',
    approvalNodeAttr: 'Node properties',
    approvalSelectNode: 'Please select node',
    approvalNodeName: 'Node name',
    approvalInput10: 'Only 10 characters can be entered',
    approvalBrancheCondtion: 'Branching condition',
    approvalSetBranche: 'Set branching conditions',
    approvalPerType: 'Type of examiner',
    approvalSelectPer: 'Select reviewer',
    approvalPerStop: 'Termination examiner',
    approvalPerStopAfter:
      'As long as the approval of the terminator is completed, the approval document will no longer continue to flow upward.',
    approvalMode: 'Approval method',
    approvalYici: 'Approval in turn',
    approvalHuanjieYici: 'The internal auditor of this link shall examine and approve in turn',
    approvalHuiqian: 'countersign',
    approvalHuiqianInfo:
      'All approvers receive the approval at the same time, and the approval must be approved by the owner',
    approvalHuoqian: 'Or sign',
    approvalHuoqianInfo:
      'All approvers receive approval at the same time, and only one person needs to approve or reject the approval',
    approvalStarePer: 'sponsoring',
    approvalDibu: 'Pending are available',
    approvalzKongque:
      'If the approver is vacant, it shall be examined and approved by the person in charge of the superior department in the address book',
    approvalSet: 'Approval settings',
    approvalMustSingtrue: 'The approval must be signed by hand',
    approvalSingtrue: 'Handwritten signature is allowed when approval is passed',
    approvalcaosong: 'Select CC',
    approvalRejectMode: 'Mode of rejection',
    approvalKefuxuan:
      'The approval person can select the rejection method according to the approval content, and you can check it',
    approvalBohui1: 'Reject to the previous node approval person',
    approvalBohui2: 'Back to the sponsor',
    approvalBohui3: 'Return to specified node',
    approvalBohui4: 'Reject and close',
    approvalCaosongMode: 'CC method',
    approvalPassCaosong: 'Copy of approval',
    approvalRejectCaosong: 'Cc of approval rejection',
    approvalEditField:
      'The fields that can be seen by the reviewer and CC person in the current phase, and the fields that can be edited by the approval person',
    approvalIsshow: 'visible',
    approvalProcessAttr: 'Process properties',
    approvalApplicant: 'applicant',
    approvalProcessMode: 'Process mode',
    approvalFixedProcess: 'Fixed process',
    approvalAnzhao: 'Implement the approval according to the established process',
    approvalFreeProcess: 'Free flow',
    approvalNotSetProcess:
      'There is no need to set up the process, and the approval process is decided by the front desk operator',
    approvalFaqiShow: 'Sponsor visible',
    approvalFaqiNotShow: 'Sponsor not visible',
    approvalProcessRemind: 'Process reminder',
    approvalEveryNodeRemind: 'The initiator is reminded when each node is approved',
    approvalAllowCehui: 'Allow sponsor to withdraw approval',
    approvalAllowCehui1:
      'Whether to allow the initiator to withdraw the approval document before it is approved',
    approvalAllowZhuanjiao: 'Allow reviewers to transfer for approval',
    approvalAllowCaosong1: 'Allow originator to CC for approval',
    approvalAllowCaosong2: 'Allow reviewer to copy for approval',
    approvalAllowCaosong3: 'Allow CC person to CC for approval',
    noSkipHistoryNode: 'Do not skip historical nodes',
    noSkipHistoryNodeRemark:
      'After the node that the task was rejected to is approved, re-approve in sequence.',
    skipHistoryNode: 'Skip historical nodes',
    skipHistoryNodeRemark:
      'Rejecting to a node and then directly returning to that node after passing through it; for example: with three nodes 1, 2, and 3, if node 3 rejects back to node 1, and automatic skipping is enabled, after node 1 is completed, it skips node 2 and goes directly to node 3.',
    approvalerRepeat: 'Duplicate removal by the examiner',
    approvalDelProcess: 'Delete process',
    approvalLiuruNode: 'Any condition can flow into the node',
    approvalLiuruNode1: 'Only when the specified conditions are met can it flow into the node',
    approvalSingle: 'Single person approval',
    approvalMore: 'Multi person approval',
    approvalDeparmentSingle: 'Department head - single level',
    approvalDeparmentMore: 'Department head - multi level',
    approvalZhidingRole: 'Assign roles',
    approvalMy: 'Sponsor himself',
    approvalOneDeparment: 'Head of first level Department',
    approvalTwoDeparment: 'Head of secondary Department',
    approvalThreeDeparment: 'Head of the third level Department',
    approvalFourDeparment: 'Head of the fourth level Department',
    approvalDontAutoRepeat: 'Do not enable automatic de duplication',
    approvalDontAutoRepeat1:
      'If the same approval person appears multiple times in the process, the duplicate will be removed automatically',
    approvalDontAutoRepeat2:
      'The same approval person appears continuously in the process, and the duplicate is automatically removed',
    approvalProcessStartNode: 'Process start node',
    approvalProcessEndNode: 'Process end node',
    approvalNewNode: 'New node',
    approvalAddNode: 'Add node',
    approvalNodeNameNotEmpty: 'Node name cannot be empty',
    approvalPleaseSelectPer: 'Please select the examiner',
    approvalSaveSuccess: 'The approval process was saved successfully',
    approvalSaveTakeEffectSuccess:
      'The approval process has been successfully saved and has become effective',
    approvalCreateModuleThen: 'Please create a module before creating a process',
    approvalInitNotDel: 'Initialized process nodes cannot be deleted',
    approvalResetIsOk:
      'After reset, the process will restore the initialization style, and all the rules that have been set will be restored. Are you sure you want to reset?',
    approvalContonMax2: 'If there are more than two conditions, advanced conditions can be set',
    approvalDelIsGoon:
      'This operation will permanently delete the process. Do you want to continue?',
    approvalDelSuccess: 'Process deleted successfully',
    approvalDelFail: 'Failed to delete process',
    pleaseSelectMatrix: 'Please select matrix',
    pleaseSelectJobPos: 'Please select a position under the matrix',
    pleaseSelectDepCompoment: 'Please select the department component corresponding to the matrix',
    unsetMatrix: 'Unset matrix',
    unsetJopPos: 'Unset job position',
    to: 'go to',
    fenlanHaveFuzeren:
      'There is a person in charge field in the current column. You can delete the column after moving it to other columns?',
    selFenlanMoveEnable:
      'By deleting the column, the field in the column will be removed to the unused field?',
    newAddColumns: 'New column',
    clickSigntrue: 'Click to sign',
    notSaveIsSaveLayout: 'The layout is not saved. Do you want to save the layout?',
    columns: 'Columns',
    unusedFields: 'Unused fields',
    customColor: 'Custom color',
    color: 'color',
    textColorSet: 'Text color settings',
    selectIcon: 'Select Icon',
    uploadIcon: 'Upload Icon',
    max10: 'Maximum 10',
    max100: 'Maximum 100',
    plsaseSelectComponents: 'Please drag the fields to the left',
    submitSuccess: 'Submitted successfully',
    textDesc: 'Text description',
    splitLine: 'Dividing line',
    button: 'button',
    pictureCarousel: 'Picture rotation',
    videoShow: 'Video display',
    staticMap: 'Static map',
    timer: 'timer',
    SignIn: 'Sign in',
    fullname: 'name',
    form: 'form',
    saveAndGoback: 'Save return',
    listFieldWidth: 'List width',
    pleaseSelectField: 'Please select field',
    content: 'content',
    buttonStyle: 'Button style',
    defaultWebform: 'default',
    customWebform: 'custom',
    textSize: 'Text size',
    buttonIcon: 'Button icon',
    buttonFillet: 'Button fillet',
    buttonHeight: 'Button height',
    autoText: 'Adapt to text',
    uploadButtonStyle: 'Upload button style',
    size: 'size',
    proposalWidthHeight: 'Recommended width height < 375 pixels x 80 pixels',
    clickEvent: 'Click event',
    selectType: 'Select type',
    lickAddress: 'Link address',
    selectLickAddress: 'Please enter the link address',
    sendEmali: 'send emails',
    linetype: 'Line type',
    linewidth: 'line width',
    linecolor: 'line color',
    clickUpload: 'Click upload',
    carouselCount: 'Number of rotations',
    lickAddressDesc: 'Link address / description',
    inputDescContent: 'Please enter the description',
    baseSet: 'Basic settings',
    carouselSpeed: 'Rotation speed',
    pictrueHeight: 'Picture height',
    videoAddress: 'Video address',
    supportTYAT: 'Support Tencent video, Youku, IQIYI, Tudou',
    outMediaPasteInput: 'Please paste the external media address into the input box',
    showAddress: 'Show location',
    inputTargetAddress: 'Enter destination address',
    timerType: 'Timer type',
    inmapShowBiaoji: 'Display information box on map marker points',
    proposalPic750450: 'The recommended image size is 750 * 450',
    jishi: 'timing',
    daojishi: 'count down',
    intoValueSecond: 'Initial value (SEC)',
    shiwFormat: 'Display format',
    arrivalDate: 'Arrival date',
    fromField: 'form field',
    selectFieldAddToFrom: 'Select fields to add to the form',
    jumpLink: 'Jump link',
    title: 'title',
    thankInputFeedback: 'We have received your feedback. Thank you for filling in',
    formSet: 'Form settings',
    formName: 'Form name',
    onlyPcVisit: 'Only PC access takes effect',
    fieldStyle: 'Field style',
    contetnBg: 'Content background',
    titleStyle: 'Title Style',
    inputAuth: 'Fill in the authority',
    set6Pwd: 'Set 6-digit password',
    linkExpand: 'Link expansion',
    linkExpandInfo:
      'Assigning extended attribute values to the same form makes the form have multiple link addresses to identify different data',
    linkExpandInfo2:
      'The extended attribute value is given to the same form to make the form have multiple link addresses, which are used to identify the source channels of different data collected.',
    expandOutlink: 'Extending the outer chain',
    expandOutlinkList: 'Expand external chain list',
    shareSet: 'Share settings',
    shareSetInfo:
      'The sharing setting information is used to share the style content displayed in the form, and is used to share to the third-party platform',
    whetherSignin: 'Check in or not',
    enable: 'enable',
    close: 'close',
    activityTheme: 'activity theme',
    signinButton: 'Check in button',
    signinTypeface: 'Sign in font',
    fypefaceColor: 'Font color',
    formStyle: 'The form style',
    signinbg: 'Sign in the background',
    restoreDefault: 'Restore default',
    use375667: 'A 375 * 667 size picture is recommended',
    validationField: 'Validation field',
    signinRestriction: 'Check in restrictions',
    openSignin: 'Allow open sign in',
    submitSuccessTips: 'Prompt for successful submission',
    callUp: 'Make a call',
    sendMessage: 'send message',
    solidLine: 'Solid line',
    dottedLine: 'Dotted line',
    dotMarking: 'Dot dash',
    doubleSolidLine: 'Double solid line',
    max4Pic: 'Add up to 4 pictures',
    max5Pic: 'Add up to 5 pictures',
    inputTabge50to1000: 'Input range: 50-1000',
    inputTabge250to1000: 'Input range: 250-1000',
    addAddress: 'Add address',
    addForm: 'New form',
    visitAuth: 'Access rights',
    release: 'release',
    sureDelWebform: 'Are you sure you want to delete this web form?',
    sureReleaseWebform: 'Are you sure you want to publish this web form?',
    sureCloseWebform: 'Are you sure you want to close the web form?',
    releaseSuccess: 'Publish successfully',
    closeSuccess: 'Closed successfully',
    copiedToClipboard: 'Copied to clipboard',
    column: 'column',
    noSelectFieldNoAttr: 'There is no field selected or the field has no properties',
    fieldEnglishName: 'Field English name',
    locking: 'locking',
    WholeCompany: 'Whole organization',
    teshuontrol: 'Special control',
    allowRemove: 'Allow removal',
    allowMove: 'Allow to move',
    allowDelete: 'Allow deletion',
    customOption: 'Custom options',
    referenceTasktTag: 'Associate collaboration task tag data',
    referenceProjectTag: 'Associated with label data of this project',
    referenceCommodity: 'Related commodity classification data',
    projectAndCustomData: 'Project and custom data',
    networkFialAgainCheck: 'Network connection failed, please check your network access again',
    multilingualSettings: 'Multilingual Settings',
    Languages: 'languages',
    addMoreLanguages: 'Add language',
    backgroundMusic: 'background music',
    sms: 'SMS verification',
    smsTip:
      'Before using this function, please bind SMS platform account in [System management] - [SMS management].',
    needSms: 'SMS verification required',
    code_error: 'Please input the verification code',
    getcode: 'Get captcha',
    appAdminer: 'Application Administrator',
    appAdminerSet: 'Application administrator settings',
    appHomepage: 'Application home page',
    quoteReport: 'Citation data analysis',
    delquoteReport: 'Delete reference data analysis',

    // 2020-10-15
    addDescription: 'Add description',
    fromTamplateCreate: 'Create from template',
    fromExcelImport: 'Import from Excel',
    sureDelModule: 'Are you sure you want to delete the module',
    delModuleTips:
      'After deletion, the module will not be recovered and the data in the module will also be deleted',
    dontWantToReport: 'No data analysis you want?',
    gotoCreate: 'To create',
    appDescFirstShow:
      'Application description, which will pop up when the user visits the application for the first time',
    excelImportInfo1:
      '1. It supports xlsx format files within 20MB, and can upload 10000 files at most',
    excelImportInfo2:
      '2. Currently, it is not supported to import and create sub forms, association relationships, automatic numbering, serial numbers, etc',
    excelImportInfo3:
      '3. Please display the field name in the first row. Merged cells cannot exist',
    excelImportInfo4: '4. The number of column sub segments shall not exceed 200 columns',
    importDataError: 'Failed to import data. Please check the downloaded error log',
    tamplatePreview: 'Template Preview',
    sampleTemplate: 'Sample template',
    pleaseAddFile: 'Please add a file',
    pleaseChooseReport: 'Please select the data analysis to be referenced',
    determineDelAppHomepage: 'Are you sure you want to delete the app home page?',
    appHaveAppHomepage:
      'There is an application home page under the app, please delete the app home page first?',
    formDesign: 'Form design',
    listSetting: 'List settings',
    detailLayout: 'Detailed layout',
    subpageNameMustfill: 'Sub page name cannot be empty',
    subpageNameNotRepeat: 'The name of sub page cannot be repeated. Please modify and save again',
    fieldSetPayNotBallback:
      'The field payment function has been enabled, but the corresponding backfill field has not been set',
    automationRules: 'Automation rules',
    layoutTipsJudge1: 'The associated module property is empty',
    layoutTipsJudge2: 'The associated field property is empty',
    layoutTipsJudge3: 'Add at least one option to level 2 or level 3',
    layoutTipsJudge4: 'Option cannot be empty',
    layoutTipsJudge5: 'Options cannot be repeated',
    layoutTipsJudge6: 'A module can only use one business information query',
    layoutTipsJudge7: 'Please select at least one corresponding field',
    layoutTipsJudge8: 'ID card name is required in smart plug-in',
    approvalCheckRepeat: 'Examine and approve duplicate',
    approvalCheckRepeat0: 'Review duplicate check settings',
    approvalCheckRepeat1:
      'Approval duplicate checking settings (duplicate checking of data in approval)',
    approvalCheckRepeat2:
      'Approval duplicate check settings (used for duplicate checking of data in approval, data in approval under the same conditions are not allowed to be submitted again (approval status = being approved and to be approved as verification data))',
    approvalCheckRepeat3: 'Conditions of duplicate checking rules',
    approvalCheckRepeat4: 'Set duplicate check rule conditions',
    approvalCheckRepeat5:
      'You can use or, and, not and English brackets to form a logical relationship between the above conditions',
    approvalCheckRepeat6:
      'For example: (1 and 2) or 3 means that after the first and second conditions and relations, then with the third condition or operation',
    approvalCheckRepeat7: 'This message is displayed after the duplicate check condition is met',
    approvalCheckRepeat8: 'Submit the save action when the conditional formula is met',
    preciseQuery: 'Precise query',
    intervalDuplicateChecking: 'Interval duplicate checking',
    approvalContionShowInfo: 'This message is required when the duplicate check conditions are met',
    gobackJuheTable: 'Return to aggregate table',
    computer: 'Computer',
    rightShowValue: 'Display the values in the list of settings on the right',
    allData: 'All data',
    listValue: 'List values',
    mobileTerminal: 'Mobile terminal',
    moduleDataList: 'Module data list',
    chooseShowFields: 'Select display field',
    chooseReportCharts: 'Select data analysis chart',
    chooseVauleChart: 'Numerical selection chart',
    listSetUpdate: 'List settings have been changed. Do you want to save them?',
    subpageSetting: 'Subpage settings',
    delSubpage: 'Delete subpage',
    fromLeftDraggableField: 'Drag and drop to add fields from the left',
    subformFieldMustLeft:
      'Subform fields can only be dragged in from the field component on the left',
    subformNotDraggField:
      'This component is not supported in the subform. Please add another component',
    subformDontToMain: 'Subform fields cannot be dragged into the main table',
    appearanceSet: 'Appearance settings',
    addColumn: 'Add column',
    pleaseDraggToSubform: 'Please drag it into the sub form corresponding to the name',
    draggableInAddFields: '(drag and drop to add fields)',
    subpageName: 'Sub page name',
    fieldDescription: 'Field description',
    digitalUnit: 'Digital unit',
    pleaseInputUnit: 'Please enter the unit, such as "piece',
    formluaMarkColor: 'Used to identify the background color of formula values',
    shibieType: 'Identification type',
    shibieCallBackSet: 'Identify backfill settings',
    callBackSet: 'Backfill settin',
    callBackSetInfo1:
      'It is used to automatically backfill the queried information into fields to improve accuracy and efficiency. Optional',
    payFunction: 'Payment function',
    payFunInfo1: 'WeChat payment and Alipay payment can be done through scan code.',
    payFunInfo2: 'Corresponding settings of payment field',
    payFunInfo3:
      'The corresponding settings are used to fill the payment feedback field into the custom component for display',
    payFunInfo4:
      'Please open the payment function in background interface integration third party interface payment access',
    payFunInfo5:
      'Payment function has been enabled. Only one field is allowed to open payment in a module. If you want to open the current field, please turn off the payment function of the original field first',
    smartPlugIn: 'Smart plug in',
    smartPlugInInfo:
      'Before using this function, set the corresponding alicloud interface account in interface integration third party platform alicloud integrate. If no interface account is configured, the function is invalid',
    shibieIDcard: 'ID card identification',
    checkSet: 'proof setup',
    checkSetInfo1: 'Used to verify the matching of name and ID number, and must fill in.',
    shoukuanInof1: 'Amount Collected',
    shoukuanInof2: 'payment method',
    shoukuanInof3: 'Collection status',
    shoukuanInof4: 'Collection time',
    shoukuanInof5: 'Transaction number',
    idCardMudtFill: 'ID card name is required',
    mustOnlyOneField: 'Please select at least one corresponding field',
    chooseFormName: 'Select form name',
    checkRepeatShowInfo1: 'This message is displayed after the duplicate check condition is met',
    checkRepeatShowInfo2: 'Submission not allowed',
    checkRepeatShowInfo3:
      'Allow to submit, prompt the above message, and support to choose whether to continue saving',
    bianhaoRule: 'Numbering rules',
    nameField: 'Name field',
    layout: 'layout',
    businessComponey: 'Business component',
    carModel: 'Car model configuration analysis',
    queryPlatforms: 'Query third-party platforms',
    aiImageTextRecognition: 'AI image-text recognition',
    clickComToLayout: 'Click the component to use in the layout',
    addRemark: 'Add notes',
    clickRightInputUrl: 'Click on the link to set input URL on the right',
    clickRightAddField: 'Click to add a display field on the right',
    headerTitleSet: 'Header title settings',
    displayStyle: 'Display style',
    biaozhun: 'standard',
    cardStyle: 'Card style',
    showHeaderFiled: 'Show header fields',
    fieldShowStyle: 'Field display style',
    upDown: 'Up and down',
    letRight: 'left and right',
    allShowStyle: 'Overall display style',
    zuheShow: 'Combined display',
    aloneShow: 'Separate display',
    showField: 'Display fields',
    more12Fields: 'Display up to 12 fields',
    showDesc: 'Display description',
    showDescInfo1: 'The description field is a multiline text field in the layout',
    addTagFields: 'Add label field',
    tagFieldsinfo1: 'The label field is a drop-down (multiple choice) field in the layout',
    valueCountSet: 'Numerical statistics settings',
    lineCount: 'Single line quantity',
    addGaojiFormula12: 'Add advanced formula fields to display up to 12',
    tabSet: 'Tab settings',
    tabShowStyle: 'Tab display style',
    tab: 'tab',
    biaoqian: 'label',
    tabWaiguan: 'Tab appearance',
    style: 'style',
    tabPosition: 'Tab location',
    tabContent: 'Tab content',
    qianruPageSet: 'Embedded page settings',
    titleName: 'Title block name',
    inputUrl: 'Enter URL',
    qianruUrlView: 'Embed URL Preview',
    qianruUrlViedoPic: 'Can embed web page, video, picture link',
    showStyle: 'Presentation style',
    defaultShow: 'Default display',
    timeListSet: 'Timeline settings',
    sortFunction: 'sort order',
    defaultStyle: 'Default style',
    style1: 'style 1',
    style2: 'style 2',
    style3: 'style 3',
    headerShow: 'Head display',
    detailsData: 'Details',
    valueCount: 'Numerical statistics',
    carousel: 'Carousel',
    carouselDescription: 'Click to set the carousel on the right',
    qianruPage: 'Embedded page',
    tabYeqian: 'tab',
    StyleOne: 'Style 1',
    StyleTwo: 'Style 2',
    StyleThree: 'Style 3',
    StyleFour: 'Style 4',
    StyleFive: 'Style 5',
    layoutDetailJudge1: 'Please select at least one header display field',
    layoutDetailJudge2: 'Please select the head display label',
    layoutDetailJudge3: 'Please select the header description field',
    layoutDetailJudge4: 'Embedded page URL cannot be empty',
    layoutDetailJudge5: 'There is an empty tab layout. Please delete and save it',
    layoutDetailJudge6: 'Wrong time axis setting',
    layoutDetailJudge7: 'Numerical statistics field cannot be empty',
    layoutDetailJudge8: 'Please select the timeline field',
    layoutDetailJudge9: 'Please enter the URL of the embedded page',
    layoutDetailJudge10: 'The URL format of the embedded web page is incorrect',
    idCardCheck: 'ID card number verification',
    idCard: 'ID card',
    moreLanguageSet: 'Multilingual Settings',
    dragpaneltouse: 'Drag components to the panel to use',
    formpage: 'Form page',
    checkinpage: 'Check in page',
    formfieldontherightside: 'Please add in the form field on the right',
    signinnow: 'Sign in now',
    signedupyet: 'Not signed up yet?',
    signup: 'sign up',
    namebackground: 'Name background color',
    signinsettings: 'Sign in settings',
    passwordaccess: 'Password access',
    password: 'password',
    published: 'published',
    unpublished: 'Unpublished',
    extendName: 'Extension',
    link: 'link',
    unnamedform: 'Unnamed form',
    workFlowTrigger: 'After automatic data creation (new data trigger in new and update execution)',
    scheduleContent: 'The schedule of the content',
    referneceDefTriggerData:
      'Association: The default association refers to the currently triggered new schedule data',
    everyYear: 'yearly',
    injionMemberNotEmpty: 'Participants cannot be empty',
    starttimeLessEndtime: 'The start time must not be greater than the end time',
    remindtimeInputJudge: 'Please enter a positive integer for the reminder time',
    starttimeIsError: 'Wrong start time',
    baseTemplate: 'Basic template',
    delCustomTemplate: 'Do you want to delete this custom template?',
    formatCheck: 'format checks',
    picTextShitbie: 'Text recognition',
    saveBtn: 'Save button',
    cancelBtn: 'Cancel button',
    buttonSetting: 'Button settings',
    more5Btn: 'Display a maximum of 5 buttons',
    showBtns: 'Display button',
    hiddneBtns: 'Folded button',
    dataSubmitCheck: 'Data submission verification',
    submitCheckJuheInfo:
      'This message is displayed under the condition satisfied formula, and the submission fails',
    juheCheckInfo1: 'Formula content is required',
    juheCheckInfo2: 'Under the condition formula, the displayed message content is required',
    checkRepeatRoleSet: 'Duplicate checking rule setting',
    gobackHomepage: 'Back to home page',
    addLanguage: 'add language',
    addLanguageMustFill: 'Added language, column name is required',
    picturedisplay: 'Picture display',
    dongtaiField: 'Dynamic field',
    currentDep: 'Current department and subordinate department',
    principalSuperior: 'Responsible person superior',
    principalDeartment: 'Department in charge',
    areyouSureDel: 'Are you sure you want to delete this dashboard data?',

    // 2020-12-25
    NodeTimeLimit: 'Node time limit',
    NodeTimeLimitInfo:
      "Set the processing deadline for the node, and automatically remind the person in charge of the node to deal with the to-do. If it doesn't work for a long time, it can automatically submit or back to avoid process stagnation.",
    NodeTimeLimitInfo1: 'Node timeout trigger timeout processing mode',
    NodeTimeLimitSet: 'Node time limit setting',
    emailRemind: 'Email reminder',
    emailRemindInfo:
      'The sender is the applicant of the approval form. The applicant needs to bind the e-mail to use this function. If it is not bound, the e-mail will not be sent back',
    emailRemindInfo1:
      'The sender is the person in charge of the current module. The person in charge needs to bind the e-mail to use this function. If it is not bound, the e-mail will not be sent back',
    emailRemindNodePer: 'Email reminder node approval person, CC person',
    emailRemindNodePer1: 'Email reminder node executor',
    emailTemplateSet: 'Mail template settings',
    nodeEndtime: 'Deadline of node approval',
    flowToCurrentNode: 'The process arrives at this node',
    PostTimeout: 'Post timeou',
    TimeoutProcessingMode: 'Timeout processing mode',
    AddProcessingMethod: 'Add processing method',
    ProcessingMethod: 'Treatment method',
    autoRemindTime: 'Automatic reminder time',
    Reminder: 'Reminder',
    remindContent: 'Reminder content',
    autoRejectTo: 'Auto return',
    autoProcessingSet: 'Automatic processing settings',
    TimeoutPerRemind: 'Remind the designated personnel after time-out',
    autoSubmitTime: 'Auto submit time',
    autoRejectTime: 'Auto return time',
    nodeProcessingEndtime: 'Processing deadline at node',
    autoSubmitNextNode: 'utomatically submit to the next approval node',
    nodeReviewer: 'Node examiner',
    PreviousNode: 'Previous node',
    ProcessSponsor: 'Process sponsor',
    customTime: 'Custom time',
    formDatemineFields: 'According to the date time field in the form',
    autoRemind: 'Automatic reminder',
    autoSubmit: 'Auto submit',
    autoReject: 'Automatic rejection',
    atThatTime: 'at that time',
    autoRemindItemNotEmpty: 'Automatic reminder time cannot be empty',
    autoRemindTimeInteger: 'Automatic reminder time must be a positive integer',
    nodeApprovalTimeRequired: 'The node approval deadline field is required',
    remindContentRequired: 'Reminder content is required',
    TimeoutReminderContent: 'Timeout reminder content',
    approvalTimeoutInfo: 'The time limit for approval is about to expire',
    flowApprovalTimeout: 'The approval limit has expired',
    PleasePositiveInteger: 'Please enter a positive integer',
    mustYouApproval: 'Your application needs your approval',
    creatingYibiaopan: 'Creating dashboards',
    editYibiaopan: 'Edit dashboard',
    yibiaopanNameRequired: 'Dashboard name is required',
    LimitSettings: 'Limit settings',
    PhotoUploadOnly: 'Photo upload only',
    listDetailEditSet: 'List editing and detail editing settings',
    listDetailEditSetInfo:
      'The switch used to edit the list and details can not edit a single field in the list or details after it is turned off. You can only click the Edit button to edit',
    submitApproval: 'Form submission for approval',
    submitApprovalDesc:
      'Enable: the form is saved directly to the approval, once enabled, the trigger event of the custom button "Initiate approval" will no longer work; Disable: the form cannot enter the approval, you need to configure the trigger event of the custom button "Initiate approval" in the global settings, save - click the custom button to enter the approval;',
    clickRightSetTabcontent: 'Click to add tab content on the right',
    newBuildYibiaopan: 'New dashboard',
    customBtnAfterClick: 'After clicking the custom button',
    approvalStatusAfterUpdate: 'After the approval status is updated',
    selectTargetCustombtn: 'Please select the custom button to trigger',
    selectTargetApprovalStatus: 'Please select the approval status that needs to be monitored',
    serialNumber: 'Serial number',
    // 20210305
    signinpage: 'Show page after sign in',
    Industry_empty: 'Industry cannot be empty',
    appType_empty: 'Application category cannot be empty',
    subformSort: 'Sub-form sorting',
    subformSortDroggable: 'Drag up and down in order of sub-forms',

    // 2021-03-31
    formulaSubmitSaveInfo: 'Commit the save action when the conditional formula is met',
    moduleNameJudge: 'The name contains only Chinese characters, English letters, and numbers',
    ListNumberSettings: 'List number Settings',
    listNumSwitch:
      'Used for the switch control of the list display quantity. If selected, this option can be selected; if not selected, this option will not be available',
    Article100PerPage: 'Article 100/page',
    Article500PerPage: 'Article 500/page',
    SubformsRecordDynamics: 'Subforms record dynamics',
    locationSetting: 'Positioning set',
    locationNearbyRange: 'Location nearby optional range',
    subformDynamicTemplate: 'Order Details subform logging template:',
    subformDynamicTip1: 'New product number [CP00001] with serial number [5] in "Order Details"',
    subformDynamicTip2:
      'In the "Order Details", the [quantity] of product [CP00001] no. [5] was changed from [52] to [100]',
    subformDynamicTip3:
      'Product number [CP00001] with serial number [5] was deleted from "Order Details"',
    subformDynamicTip4: 'Unique identification of subform fields',
    subformDynamicTip5: 'Subform record dynamic fields contain:',
    subformNotSetFields: 'The subform has no fields set',
    subformDynamicTip4required: 'The subform field uniquely identifies mandatory',
    subformDynamicTip5required: 'Subform record dynamic fields Mandatory',
    UppercaseLettersNum: 'Uppercase letters + digits',
    LowercaseLettersNum: 'Lowercase letters + digits',
    UppercaseLowercaseLettersNum: 'Uppercase and lowercase letters + digits',
    AssociatedTarget: 'Associated target',
    GetSssociatedModuleValue: 'Gets the associated module value',
    ComponentName: 'Component name',
    DynamicTimeNull: 'Dynamic time is null',
    ReadFields: 'Read fields',
    SubmitNum_1: 'Submission quantity control',
    SubmitNum_2: 'Control the number of associated modules submitted',
    SubmitNum_3: 'If the submission limit is exceeded, please note:',
    SubmitNum_4: 'Submitted data has verification (valid data if not set)',
    SignInShowInformation: 'Sign-in unreserved display information',
    GetSssociationMapping: 'Obtained by association mapping',
    allApp: 'All application',
    createAppFromTemplate: 'Creating an application from a template',
    allowSenderRevoke: 'Allow the sponsor to revoke the approval form in the approval process',
    listPtimization: 'List performance optimization',
    listPtimizationInfo:
      'Used to control the total number of lists displayed and paging, optimizing performance in large number',
    listPageSet: 'List paging',
    showBeforeOnly: 'Pre-display only',
    listGlobalSearch: 'List global search',
    listGlobalSearchInfo:
      'After this function is enabled, the global search function is displayed in the list. You can search text and numeric components through fuzzy search. (This function is enabled when the number of module fields is less than 30)',
    listDataShowControl: 'List data display control',
    listDataShowControlInfo:
      'It is only used for large amount of data in the current module. If it is checked, the data in the list is not displayed by default in all submenus, and the filtered data can be displayed only after filtering in column fields',
    checkListDataHiddle: 'If checked, the list data will not be displayed',
    fieldIndex: 'Field index',
    fieldIndexInfo:
      'After this field is selected, the field index function is established in the database to optimize the database query speed',
    visiblePermission: 'Visible permission',
    editPermission: 'Edit permission',
    approvalNodeLineError1: 'The start node cannot be directly connected to the end node',
    approvalNodeLineError2: 'There must be incoming and outgoing wires',
    approvalNodeLineError3: 'No',
    approvalNodeLineError4: 'output line',
    approvalNodeLineError5: 'input line',
    approvalNodeLineError6: 'The start node must be in the first phase'
  }
}
